// extracted by mini-css-extract-plugin
module.exports = {"feedback-area":"Feedback_feedback-area__pib5q","feedback-button":"Feedback_feedback-button__xD_dh"};